import { CompanyBetaProgramsTabWebComponent } from './component/CompanyBetaProgramsTabWebComponent';
import { WEB_COMPONENT_COMPANY_BETA_PROGRAMS_TAB } from '../../../webcomponents.constants';

export { CompanyBetaProgramsTabWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANY_BETA_PROGRAMS_TAB, CompanyBetaProgramsTabWebComponent);
